import type { HeadItemType } from 'components/Table'

const headColumns: HeadItemType[] = [
  { columnName: '', label: '', sortable: false },
  {
    columnName: 'Causa',
    label: 'Causa',
    sortable: true,
  },
  { columnName: 'DataSolicitacao', label: 'Solicitação', sortable: true },
  {
    columnName: 'CodigoSapCliente',
    label: 'SAP cliente',
    sortable: true,
  },
  {
    columnName: 'RazaoSocial',
    label: 'Razão social',
    sortable: true,
  },
  {
    columnName: 'NumeroOrdemVendaPortal',
    label: 'OV portal',
    sortable: true,
  },
  {
    columnName: 'CondicaoPagamento',
    label: 'Cond. pgmto.',
    sortable: true,
  },
  {
    columnName: 'PrazoDevido',
    label: 'Prazo devido',
    sortable: true,
  },
  {
    columnName: 'PrazoAplicado',
    label: 'Prazo aplicado',
    sortable: true,
  },
  {
    columnName: 'ValorDescontoMaximo',
    label: 'Desc. devido',
    sortable: true,
  },
  {
    columnName: 'ValorDescontoAplicado',
    label: 'Desc. aplicado',
    sortable: true,
  },
  {
    columnName: 'ValorDescontoExcedente',
    label: 'Desc. excedente',
    sortable: true,
  },
  { columnName: 'Aprovador', label: 'Aprovador', sortable: true },
  { columnName: 'DataAprovacao', label: 'Aprovação', sortable: true },
  {
    columnName: 'QuantidadePares',
    label: 'Qtd. pares',
    sortable: true,
  },
  {
    columnName: 'TipoOrdemVenda',
    label: 'Tipo de OV',
    sortable: true,
  },
  {
    columnName: 'ForaDeLinha',
    label: 'F.L.',
    sortable: true,
  },
  {
    columnName: 'MesCota',
    label: 'Mês cota',
    sortable: true,
  },
  {
    actionsLabel: true,
    columnName: 'acoes',
    label: 'Ações',
    sortable: false,
  },
]

export default headColumns
